export default () => ({
    token: localStorage.getItem('token') || 0
})